import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  getAppointmentList,
  getAppointmentVCPDetails,
  getTodayAppointments,
  getUpcomingAppointment,
  TAG_APPOINTMENT_LIST,
  TAG_TODAY_APPOINTMENTS,
  TAG_VCP_DETAILS,
  UPCOMING_APPOINTMENT_TAGS,
} from './endpoints';

export const getAppointmentsApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getAppointmentList: getAppointmentList(builder),
      getAppointmentVCPDetails: getAppointmentVCPDetails(builder),
      getTodayAppointments: getTodayAppointments(builder),
      getUpcomingAppointment: getUpcomingAppointment(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [TAG_APPOINTMENT_LIST, TAG_TODAY_APPOINTMENTS, TAG_VCP_DETAILS, UPCOMING_APPOINTMENT_TAGS],
  });

export const {
  useGetAppointmentListQuery,
  useGetAppointmentVCPDetailsQuery,
  useGetTodayAppointmentsQuery,
  useGetUpcomingAppointmentQuery,
  useLazyGetTodayAppointmentsQuery,
} = getAppointmentsApi;
